import script from "./ChessBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChessBoard.vue?vue&type=script&setup=true&lang=js"

import "./ChessBoard.vue?vue&type=style&index=0&id=0cfd8eff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cfd8eff"]])

export default __exports__